import api from './api';

const usuarioService = {
  // ==========================================
  // USUARIOS
  // ==========================================
  
  // Obtener todos los usuarios
  obtenerUsuarios: async () => {
    try {
      const response = await api.get('/usuarios');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Crear usuario
  crearUsuario: async (datosUsuario) => {
    try {
      const response = await api.post('/usuarios', datosUsuario);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Actualizar usuario
  actualizarUsuario: async (id, datosUsuario) => {
    try {
      const response = await api.put(`/usuarios/${id}`, datosUsuario);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Eliminar usuario
  eliminarUsuario: async (id) => {
    try {
      const response = await api.delete(`/usuarios/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Verificar disponibilidad de nombre de usuario
  verificarNombreUsuario: async (nombreUsu, excludeId = null) => {
    try {
      const params = excludeId ? `?excludeId=${excludeId}` : '';
      const response = await api.get(`/usuarios/verificar/${nombreUsu}${params}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Obtener sugerencias de nombre de usuario
  sugerirNombreUsuario: async (nombre, apellidoPat, apellidoMat = '') => {
    try {
      const response = await api.get('/usuarios/sugerir', {
        params: { nombre, apellidoPat, apellidoMat }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // ==========================================
  // ROLES
  // ==========================================

  // Obtener todos los roles
  obtenerRoles: async () => {
    try {
      const response = await api.get('/usuarios/roles');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Obtener todos los permisos
  obtenerPermisos: async () => {
    try {
      const response = await api.get('/usuarios/permisos');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Crear rol
  crearRol: async (datosRol) => {
    try {
      const response = await api.post('/usuarios/roles', datosRol);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Actualizar rol
  actualizarRol: async (id, datosRol) => {
    try {
      const response = await api.put(`/usuarios/roles/${id}`, datosRol);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Eliminar rol
  eliminarRol: async (id) => {
    try {
      const response = await api.delete(`/usuarios/roles/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

export default usuarioService;